module.exports = __webpack_public_path__ + "img/Hailsham-Roadways.5c85cb39.jpg";